import { PaymentInputWUT } from '@wix/form-fields/viewer-wut';

export default PaymentInputWUT;
